import { Contract, ethers, randomBytes } from 'ethers';
import onlyPino from 'pino';
import hash from 'js-sha512';
import { poseidon16, poseidon15, poseidon14, poseidon13, poseidon12, poseidon11, poseidon10, poseidon9, poseidon8, poseidon7, poseidon6, poseidon5, poseidon4, poseidon3, poseidon2, poseidon1 } from 'poseidon-lite';
import { BigNumber } from '@ethersproject/bignumber';
import { groth16 } from 'snarkjs';

var ENTRY_POINT_ABI = [
	{
		inputs: [
			{
				internalType: "uint256",
				name: "preOpGas",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "paid",
				type: "uint256"
			},
			{
				internalType: "uint48",
				name: "validAfter",
				type: "uint48"
			},
			{
				internalType: "uint48",
				name: "validUntil",
				type: "uint48"
			},
			{
				internalType: "bool",
				name: "targetSuccess",
				type: "bool"
			},
			{
				internalType: "bytes",
				name: "targetResult",
				type: "bytes"
			}
		],
		name: "ExecutionResult",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "opIndex",
				type: "uint256"
			},
			{
				internalType: "string",
				name: "reason",
				type: "string"
			}
		],
		name: "FailedOp",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "sender",
				type: "address"
			}
		],
		name: "SenderAddressResult",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "aggregator",
				type: "address"
			}
		],
		name: "SignatureValidationFailed",
		type: "error"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "uint256",
						name: "preOpGas",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "prefund",
						type: "uint256"
					},
					{
						internalType: "bool",
						name: "sigFailed",
						type: "bool"
					},
					{
						internalType: "uint48",
						name: "validAfter",
						type: "uint48"
					},
					{
						internalType: "uint48",
						name: "validUntil",
						type: "uint48"
					},
					{
						internalType: "bytes",
						name: "paymasterContext",
						type: "bytes"
					}
				],
				internalType: "struct IEntryPoint.ReturnInfo",
				name: "returnInfo",
				type: "tuple"
			},
			{
				components: [
					{
						internalType: "uint256",
						name: "stake",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "unstakeDelaySec",
						type: "uint256"
					}
				],
				internalType: "struct IStakeManager.StakeInfo",
				name: "senderInfo",
				type: "tuple"
			},
			{
				components: [
					{
						internalType: "uint256",
						name: "stake",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "unstakeDelaySec",
						type: "uint256"
					}
				],
				internalType: "struct IStakeManager.StakeInfo",
				name: "factoryInfo",
				type: "tuple"
			},
			{
				components: [
					{
						internalType: "uint256",
						name: "stake",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "unstakeDelaySec",
						type: "uint256"
					}
				],
				internalType: "struct IStakeManager.StakeInfo",
				name: "paymasterInfo",
				type: "tuple"
			}
		],
		name: "ValidationResult",
		type: "error"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "uint256",
						name: "preOpGas",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "prefund",
						type: "uint256"
					},
					{
						internalType: "bool",
						name: "sigFailed",
						type: "bool"
					},
					{
						internalType: "uint48",
						name: "validAfter",
						type: "uint48"
					},
					{
						internalType: "uint48",
						name: "validUntil",
						type: "uint48"
					},
					{
						internalType: "bytes",
						name: "paymasterContext",
						type: "bytes"
					}
				],
				internalType: "struct IEntryPoint.ReturnInfo",
				name: "returnInfo",
				type: "tuple"
			},
			{
				components: [
					{
						internalType: "uint256",
						name: "stake",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "unstakeDelaySec",
						type: "uint256"
					}
				],
				internalType: "struct IStakeManager.StakeInfo",
				name: "senderInfo",
				type: "tuple"
			},
			{
				components: [
					{
						internalType: "uint256",
						name: "stake",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "unstakeDelaySec",
						type: "uint256"
					}
				],
				internalType: "struct IStakeManager.StakeInfo",
				name: "factoryInfo",
				type: "tuple"
			},
			{
				components: [
					{
						internalType: "uint256",
						name: "stake",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "unstakeDelaySec",
						type: "uint256"
					}
				],
				internalType: "struct IStakeManager.StakeInfo",
				name: "paymasterInfo",
				type: "tuple"
			},
			{
				components: [
					{
						internalType: "address",
						name: "aggregator",
						type: "address"
					},
					{
						components: [
							{
								internalType: "uint256",
								name: "stake",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "unstakeDelaySec",
								type: "uint256"
							}
						],
						internalType: "struct IStakeManager.StakeInfo",
						name: "stakeInfo",
						type: "tuple"
					}
				],
				internalType: "struct IEntryPoint.AggregatorStakeInfo",
				name: "aggregatorInfo",
				type: "tuple"
			}
		],
		name: "ValidationResultWithAggregation",
		type: "error"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "bytes32",
				name: "userOpHash",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "address",
				name: "sender",
				type: "address"
			},
			{
				indexed: false,
				internalType: "address",
				name: "factory",
				type: "address"
			},
			{
				indexed: false,
				internalType: "address",
				name: "paymaster",
				type: "address"
			}
		],
		name: "AccountDeployed",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
		],
		name: "BeforeExecution",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "totalDeposit",
				type: "uint256"
			}
		],
		name: "Deposited",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "aggregator",
				type: "address"
			}
		],
		name: "SignatureAggregatorChanged",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "totalStaked",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "withdrawTime",
				type: "uint256"
			}
		],
		name: "StakeLocked",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "withdrawTime",
				type: "uint256"
			}
		],
		name: "StakeUnlocked",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				indexed: false,
				internalType: "address",
				name: "withdrawAddress",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "StakeWithdrawn",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "bytes32",
				name: "userOpHash",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "address",
				name: "sender",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "paymaster",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "nonce",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "bool",
				name: "success",
				type: "bool"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "actualGasCost",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "actualGasUsed",
				type: "uint256"
			}
		],
		name: "UserOperationEvent",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "bytes32",
				name: "userOpHash",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "address",
				name: "sender",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "nonce",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "bytes",
				name: "revertReason",
				type: "bytes"
			}
		],
		name: "UserOperationRevertReason",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				indexed: false,
				internalType: "address",
				name: "withdrawAddress",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "Withdrawn",
		type: "event"
	},
	{
		inputs: [
		],
		name: "SIG_VALIDATION_FAILED",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes",
				name: "initCode",
				type: "bytes"
			},
			{
				internalType: "address",
				name: "sender",
				type: "address"
			},
			{
				internalType: "bytes",
				name: "paymasterAndData",
				type: "bytes"
			}
		],
		name: "_validateSenderAndPaymaster",
		outputs: [
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint32",
				name: "unstakeDelaySec",
				type: "uint32"
			}
		],
		name: "addStake",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "balanceOf",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "depositTo",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		name: "deposits",
		outputs: [
			{
				internalType: "uint112",
				name: "deposit",
				type: "uint112"
			},
			{
				internalType: "bool",
				name: "staked",
				type: "bool"
			},
			{
				internalType: "uint112",
				name: "stake",
				type: "uint112"
			},
			{
				internalType: "uint32",
				name: "unstakeDelaySec",
				type: "uint32"
			},
			{
				internalType: "uint64",
				name: "withdrawTime",
				type: "uint64"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "getDepositInfo",
		outputs: [
			{
				components: [
					{
						internalType: "uint112",
						name: "deposit",
						type: "uint112"
					},
					{
						internalType: "bool",
						name: "staked",
						type: "bool"
					},
					{
						internalType: "uint112",
						name: "stake",
						type: "uint112"
					},
					{
						internalType: "uint32",
						name: "unstakeDelaySec",
						type: "uint32"
					},
					{
						internalType: "uint64",
						name: "withdrawTime",
						type: "uint64"
					}
				],
				internalType: "struct IStakeManager.DepositInfo",
				name: "info",
				type: "tuple"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "sender",
				type: "address"
			},
			{
				internalType: "uint192",
				name: "key",
				type: "uint192"
			}
		],
		name: "getNonce",
		outputs: [
			{
				internalType: "uint256",
				name: "nonce",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes",
				name: "initCode",
				type: "bytes"
			}
		],
		name: "getSenderAddress",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "address",
						name: "sender",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "nonce",
						type: "uint256"
					},
					{
						internalType: "bytes",
						name: "initCode",
						type: "bytes"
					},
					{
						internalType: "bytes",
						name: "callData",
						type: "bytes"
					},
					{
						internalType: "uint256",
						name: "callGasLimit",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "verificationGasLimit",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "preVerificationGas",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "maxFeePerGas",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "maxPriorityFeePerGas",
						type: "uint256"
					},
					{
						internalType: "bytes",
						name: "paymasterAndData",
						type: "bytes"
					},
					{
						internalType: "bytes",
						name: "signature",
						type: "bytes"
					}
				],
				internalType: "struct UserOperation",
				name: "userOp",
				type: "tuple"
			}
		],
		name: "getUserOpHash",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						components: [
							{
								internalType: "address",
								name: "sender",
								type: "address"
							},
							{
								internalType: "uint256",
								name: "nonce",
								type: "uint256"
							},
							{
								internalType: "bytes",
								name: "initCode",
								type: "bytes"
							},
							{
								internalType: "bytes",
								name: "callData",
								type: "bytes"
							},
							{
								internalType: "uint256",
								name: "callGasLimit",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "verificationGasLimit",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "preVerificationGas",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "maxFeePerGas",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "maxPriorityFeePerGas",
								type: "uint256"
							},
							{
								internalType: "bytes",
								name: "paymasterAndData",
								type: "bytes"
							},
							{
								internalType: "bytes",
								name: "signature",
								type: "bytes"
							}
						],
						internalType: "struct UserOperation[]",
						name: "userOps",
						type: "tuple[]"
					},
					{
						internalType: "contract IAggregator",
						name: "aggregator",
						type: "address"
					},
					{
						internalType: "bytes",
						name: "signature",
						type: "bytes"
					}
				],
				internalType: "struct IEntryPoint.UserOpsPerAggregator[]",
				name: "opsPerAggregator",
				type: "tuple[]"
			},
			{
				internalType: "address payable",
				name: "beneficiary",
				type: "address"
			}
		],
		name: "handleAggregatedOps",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "address",
						name: "sender",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "nonce",
						type: "uint256"
					},
					{
						internalType: "bytes",
						name: "initCode",
						type: "bytes"
					},
					{
						internalType: "bytes",
						name: "callData",
						type: "bytes"
					},
					{
						internalType: "uint256",
						name: "callGasLimit",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "verificationGasLimit",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "preVerificationGas",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "maxFeePerGas",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "maxPriorityFeePerGas",
						type: "uint256"
					},
					{
						internalType: "bytes",
						name: "paymasterAndData",
						type: "bytes"
					},
					{
						internalType: "bytes",
						name: "signature",
						type: "bytes"
					}
				],
				internalType: "struct UserOperation[]",
				name: "ops",
				type: "tuple[]"
			},
			{
				internalType: "address payable",
				name: "beneficiary",
				type: "address"
			}
		],
		name: "handleOps",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint192",
				name: "key",
				type: "uint192"
			}
		],
		name: "incrementNonce",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes",
				name: "callData",
				type: "bytes"
			},
			{
				components: [
					{
						components: [
							{
								internalType: "address",
								name: "sender",
								type: "address"
							},
							{
								internalType: "uint256",
								name: "nonce",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "callGasLimit",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "verificationGasLimit",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "preVerificationGas",
								type: "uint256"
							},
							{
								internalType: "address",
								name: "paymaster",
								type: "address"
							},
							{
								internalType: "uint256",
								name: "maxFeePerGas",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "maxPriorityFeePerGas",
								type: "uint256"
							}
						],
						internalType: "struct EntryPoint.MemoryUserOp",
						name: "mUserOp",
						type: "tuple"
					},
					{
						internalType: "bytes32",
						name: "userOpHash",
						type: "bytes32"
					},
					{
						internalType: "uint256",
						name: "prefund",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "contextOffset",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "preOpGas",
						type: "uint256"
					}
				],
				internalType: "struct EntryPoint.UserOpInfo",
				name: "opInfo",
				type: "tuple"
			},
			{
				internalType: "bytes",
				name: "context",
				type: "bytes"
			}
		],
		name: "innerHandleOp",
		outputs: [
			{
				internalType: "uint256",
				name: "actualGasCost",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			},
			{
				internalType: "uint192",
				name: "",
				type: "uint192"
			}
		],
		name: "nonceSequenceNumber",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "address",
						name: "sender",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "nonce",
						type: "uint256"
					},
					{
						internalType: "bytes",
						name: "initCode",
						type: "bytes"
					},
					{
						internalType: "bytes",
						name: "callData",
						type: "bytes"
					},
					{
						internalType: "uint256",
						name: "callGasLimit",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "verificationGasLimit",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "preVerificationGas",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "maxFeePerGas",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "maxPriorityFeePerGas",
						type: "uint256"
					},
					{
						internalType: "bytes",
						name: "paymasterAndData",
						type: "bytes"
					},
					{
						internalType: "bytes",
						name: "signature",
						type: "bytes"
					}
				],
				internalType: "struct UserOperation",
				name: "op",
				type: "tuple"
			},
			{
				internalType: "address",
				name: "target",
				type: "address"
			},
			{
				internalType: "bytes",
				name: "targetCallData",
				type: "bytes"
			}
		],
		name: "simulateHandleOp",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "address",
						name: "sender",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "nonce",
						type: "uint256"
					},
					{
						internalType: "bytes",
						name: "initCode",
						type: "bytes"
					},
					{
						internalType: "bytes",
						name: "callData",
						type: "bytes"
					},
					{
						internalType: "uint256",
						name: "callGasLimit",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "verificationGasLimit",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "preVerificationGas",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "maxFeePerGas",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "maxPriorityFeePerGas",
						type: "uint256"
					},
					{
						internalType: "bytes",
						name: "paymasterAndData",
						type: "bytes"
					},
					{
						internalType: "bytes",
						name: "signature",
						type: "bytes"
					}
				],
				internalType: "struct UserOperation",
				name: "userOp",
				type: "tuple"
			}
		],
		name: "simulateValidation",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "unlockStake",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address payable",
				name: "withdrawAddress",
				type: "address"
			}
		],
		name: "withdrawStake",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address payable",
				name: "withdrawAddress",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "withdrawAmount",
				type: "uint256"
			}
		],
		name: "withdrawTo",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		stateMutability: "payable",
		type: "receive"
	}
];

var ZERO_TRUST_ACCOUNT_ABI = [
	{
		inputs: [
			{
				internalType: "contract IEntryPoint",
				name: "anEntryPoint",
				type: "address"
			},
			{
				internalType: "contract IZeroTrustSessionVerifier",
				name: "sessionVerifier",
				type: "address"
			}
		],
		stateMutability: "nonpayable",
		type: "constructor"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "previousAdmin",
				type: "address"
			},
			{
				indexed: false,
				internalType: "address",
				name: "newAdmin",
				type: "address"
			}
		],
		name: "AdminChanged",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "beacon",
				type: "address"
			}
		],
		name: "BeaconUpgraded",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint8",
				name: "version",
				type: "uint8"
			}
		],
		name: "Initialized",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "contract IEntryPoint",
				name: "entryPoint",
				type: "address"
			},
			{
				components: [
					{
						internalType: "uint256",
						name: "pubKeyX",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "pubKeyY",
						type: "uint256"
					},
					{
						internalType: "bytes",
						name: "credentialId",
						type: "bytes"
					}
				],
				indexed: true,
				internalType: "struct IPasskeyAccount.Passkey",
				name: "signer",
				type: "tuple"
			}
		],
		name: "PasskeyZkAccountInitialized",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "implementation",
				type: "address"
			}
		],
		name: "Upgraded",
		type: "event"
	},
	{
		inputs: [
		],
		name: "_signer",
		outputs: [
			{
				internalType: "uint256",
				name: "pubKeyX",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "pubKeyY",
				type: "uint256"
			},
			{
				internalType: "bytes",
				name: "credentialId",
				type: "bytes"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "addDeposit",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "appName",
				type: "bytes32"
			}
		],
		name: "endApplicationSession",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "entryPoint",
		outputs: [
			{
				internalType: "contract IEntryPoint",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "dest",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "value",
				type: "uint256"
			},
			{
				internalType: "bytes",
				name: "func",
				type: "bytes"
			}
		],
		name: "execute",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address[]",
				name: "dest",
				type: "address[]"
			},
			{
				internalType: "uint256[]",
				name: "value",
				type: "uint256[]"
			},
			{
				internalType: "bytes[]",
				name: "func",
				type: "bytes[]"
			}
		],
		name: "executeBatch",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "dest",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "value",
				type: "uint256"
			},
			{
				internalType: "bytes",
				name: "func",
				type: "bytes"
			}
		],
		name: "executeOnSession",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "appName",
				type: "bytes32"
			}
		],
		name: "getApplicationSession",
		outputs: [
			{
				components: [
					{
						internalType: "uint256",
						name: "sessionCommitment",
						type: "uint256"
					},
					{
						internalType: "uint48",
						name: "allowedContracts",
						type: "uint48"
					},
					{
						internalType: "uint48",
						name: "validUntil",
						type: "uint48"
					},
					{
						internalType: "uint48",
						name: "validAfter",
						type: "uint48"
					},
					{
						internalType: "uint48",
						name: "allowedInactiveDuration",
						type: "uint48"
					},
					{
						internalType: "bool",
						name: "extendWithInactiveDuration",
						type: "bool"
					}
				],
				internalType: "struct ISessionAccount.Session",
				name: "",
				type: "tuple"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getDeposit",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getNonce",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "pubKeyX",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "pubKeyY",
				type: "uint256"
			},
			{
				internalType: "bytes",
				name: "credentialId",
				type: "bytes"
			}
		],
		name: "initialize",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			},
			{
				internalType: "address",
				name: "",
				type: "address"
			},
			{
				internalType: "uint256[]",
				name: "",
				type: "uint256[]"
			},
			{
				internalType: "uint256[]",
				name: "",
				type: "uint256[]"
			},
			{
				internalType: "bytes",
				name: "",
				type: "bytes"
			}
		],
		name: "onERC1155BatchReceived",
		outputs: [
			{
				internalType: "bytes4",
				name: "",
				type: "bytes4"
			}
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			},
			{
				internalType: "address",
				name: "",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			},
			{
				internalType: "bytes",
				name: "",
				type: "bytes"
			}
		],
		name: "onERC1155Received",
		outputs: [
			{
				internalType: "bytes4",
				name: "",
				type: "bytes4"
			}
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			},
			{
				internalType: "address",
				name: "",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			},
			{
				internalType: "bytes",
				name: "",
				type: "bytes"
			}
		],
		name: "onERC721Received",
		outputs: [
			{
				internalType: "bytes4",
				name: "",
				type: "bytes4"
			}
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "uint256",
						name: "challengeLocation",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "responseTypeLocation",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "r",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "s",
						type: "uint256"
					},
					{
						internalType: "bool",
						name: "requireUserVerification",
						type: "bool"
					},
					{
						internalType: "bytes",
						name: "authenticatorData",
						type: "bytes"
					},
					{
						internalType: "string",
						name: "clientDataJSON",
						type: "string"
					}
				],
				internalType: "struct IPasskeyAccount.PasskeySigData",
				name: "sig",
				type: "tuple"
			}
		],
		name: "passkeySignatureStruct",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "proxiableUUID",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "bytes32",
						name: "appName",
						type: "bytes32"
					},
					{
						internalType: "uint256",
						name: "nullifierHash",
						type: "uint256"
					},
					{
						internalType: "uint256[8]",
						name: "values",
						type: "uint256[8]"
					}
				],
				internalType: "struct ISessionAccount.SessionSignatureProof",
				name: "sig",
				type: "tuple"
			}
		],
		name: "sessionSignatureProofStruct",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "appName",
				type: "bytes32"
			},
			{
				components: [
					{
						internalType: "uint256",
						name: "sessionCommitment",
						type: "uint256"
					},
					{
						internalType: "uint48",
						name: "allowedContracts",
						type: "uint48"
					},
					{
						internalType: "uint48",
						name: "validUntil",
						type: "uint48"
					},
					{
						internalType: "uint48",
						name: "validAfter",
						type: "uint48"
					},
					{
						internalType: "uint48",
						name: "allowedInactiveDuration",
						type: "uint48"
					},
					{
						internalType: "bool",
						name: "extendWithInactiveDuration",
						type: "bool"
					}
				],
				internalType: "struct ISessionAccount.Session",
				name: "session",
				type: "tuple"
			}
		],
		name: "setApplicationSession",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes4",
				name: "interfaceId",
				type: "bytes4"
			}
		],
		name: "supportsInterface",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			},
			{
				internalType: "address",
				name: "",
				type: "address"
			},
			{
				internalType: "address",
				name: "",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			},
			{
				internalType: "bytes",
				name: "",
				type: "bytes"
			},
			{
				internalType: "bytes",
				name: "",
				type: "bytes"
			}
		],
		name: "tokensReceived",
		outputs: [
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "newImplementation",
				type: "address"
			}
		],
		name: "upgradeTo",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "newImplementation",
				type: "address"
			},
			{
				internalType: "bytes",
				name: "data",
				type: "bytes"
			}
		],
		name: "upgradeToAndCall",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "address",
						name: "sender",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "nonce",
						type: "uint256"
					},
					{
						internalType: "bytes",
						name: "initCode",
						type: "bytes"
					},
					{
						internalType: "bytes",
						name: "callData",
						type: "bytes"
					},
					{
						internalType: "uint256",
						name: "callGasLimit",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "verificationGasLimit",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "preVerificationGas",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "maxFeePerGas",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "maxPriorityFeePerGas",
						type: "uint256"
					},
					{
						internalType: "bytes",
						name: "paymasterAndData",
						type: "bytes"
					},
					{
						internalType: "bytes",
						name: "signature",
						type: "bytes"
					}
				],
				internalType: "struct UserOperation",
				name: "userOp",
				type: "tuple"
			},
			{
				internalType: "bytes32",
				name: "userOpHash",
				type: "bytes32"
			},
			{
				internalType: "uint256",
				name: "missingAccountFunds",
				type: "uint256"
			}
		],
		name: "validateUserOp",
		outputs: [
			{
				internalType: "uint256",
				name: "validationData",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address payable",
				name: "withdrawAddress",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "withdrawDepositTo",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		stateMutability: "payable",
		type: "receive"
	}
];

var ZERO_TRUST_ACCOUNT_FACTORY_ABI = [
	{
		inputs: [
			{
				internalType: "contract IEntryPoint",
				name: "_entryPoint",
				type: "address"
			},
			{
				internalType: "contract IZeroTrustSessionVerifier",
				name: "_sessionVerifier",
				type: "address"
			}
		],
		stateMutability: "nonpayable",
		type: "constructor"
	},
	{
		inputs: [
		],
		name: "accountImplementation",
		outputs: [
			{
				internalType: "contract ZeroTrustAccount",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "pubKeyX",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "pubKeyY",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "salt",
				type: "uint256"
			},
			{
				internalType: "bytes",
				name: "credentialId",
				type: "bytes"
			}
		],
		name: "createAccount",
		outputs: [
			{
				internalType: "contract ZeroTrustAccount",
				name: "ret",
				type: "address"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "pubKeyX",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "pubKeyY",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "salt",
				type: "uint256"
			},
			{
				internalType: "bytes",
				name: "credentialId",
				type: "bytes"
			}
		],
		name: "getCounterfactualAddress",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	}
];

const logger = onlyPino({
    level: "debug",
});

const getNonceValue = async (address, provider) => {
    const contract = new Contract(address, ["function getNonce() view returns(uint256)"], provider);
    let nonceValue = 0;
    try {
        nonceValue = await contract['getNonce']();
    }
    catch (error) {
        logger.info("Error fetching nonce:", error);
    }
    finally {
        return nonceValue;
    }
};

var PASSKEY_ERRORS;
(function (PASSKEY_ERRORS) {
    PASSKEY_ERRORS["USER_REJECTED_CREDENTIAL"] = "The user rejected the creation of the Passkey, likely due to canceling the prompt.";
    PASSKEY_ERRORS["UNABLE_TO_RETRIEVE_CREDENTIAL"] = "The get request failed, either due to lack of credentials in device or user cancelling action.";
    PASSKEY_ERRORS["BROWSER_DOES_NOT_SUPPORT_PASSKEY"] = "The browser does not support Passkey, or the context does not expose it (e.g. a non-HTTPS page).";
    PASSKEY_ERRORS["CREDENTIAL_NOT_CREATED"] = "The credential has not been created yet.";
    PASSKEY_ERRORS["ERROR_RETRIEVING_RAW_ID"] = "There was an error retrieving the rawId from the credential.";
    PASSKEY_ERRORS["INVALID_CREDENTIAL_RESPONSE"] = "The provided response is not a valid response object from a get or create call";
    PASSKEY_ERRORS["CREDENTIAL_RESPONSE_HAS_NO_PUBLIC_KEY"] = "The provided response is not an attestation response and has no public key";
    PASSKEY_ERRORS["PUBLIC_KEY_CANT_BE_PARSED_AS_CRYPTO_KEY"] = "Unable to load key, the provided ArrayBuffer isn\u2019t a valid key.";
})(PASSKEY_ERRORS || (PASSKEY_ERRORS = {}));

var _a;
const truncate = (word) => word && `...${word.substr(word.length - 10, word.length)}`;
class Passkey {
    static getPublicKeyFromAttestationResponse({ response, }) {
        if (!response) {
            return { data: null, error: PASSKEY_ERRORS.INVALID_CREDENTIAL_RESPONSE };
        }
        try {
            const publicKey = response.getPublicKey();
            const publicKeyAsHex = _a.buf2hex(publicKey);
            logger.debug("(🪪,ℹ️) Public Key as Hex", publicKeyAsHex);
            return { data: publicKey, error: null };
        }
        catch (e) {
            logger.error(PASSKEY_ERRORS.CREDENTIAL_RESPONSE_HAS_NO_PUBLIC_KEY, e);
            return {
                data: null,
                error: PASSKEY_ERRORS.CREDENTIAL_RESPONSE_HAS_NO_PUBLIC_KEY,
            };
        }
    }
    static async get({ allowCredentials = [] }) {
        logger.debug('(🪪,ℹ️) Obtaining credentials');
        const randomUUID = crypto.randomUUID();
        const challenge = this.hex2buf(randomUUID);
        logger.debug('(🪄,ℹ️) Challenge', challenge);
        logger.debug('(🪄,ℹ️) Challenge (base64)', this.toBase64url(challenge));
        logger.debug('(🪄,ℹ️) Challenge (hex)', this.buf2hex(challenge));
        try {
            const publicKeyCredentialRequestOptions = {
                challenge,
                timeout: 60000,
                allowCredentials,
            };
            const assertion = (await navigator.credentials.get({
                publicKey: publicKeyCredentialRequestOptions,
            }));
            return { data: assertion, response: assertion.response, error: null };
        }
        catch (e) {
            logger.error(PASSKEY_ERRORS.UNABLE_TO_RETRIEVE_CREDENTIAL, e);
            return { data: null, response: null, error: PASSKEY_ERRORS.UNABLE_TO_RETRIEVE_CREDENTIAL };
        }
    }
    static async create({ appName, name, displayName, yubikeyOnly, }) {
        logger.debug(`(🪪,ℹ️) Creating credential for ${name}`);
        try {
            if (!navigator.credentials) {
                return {
                    data: null,
                    response: null,
                    error: PASSKEY_ERRORS.BROWSER_DOES_NOT_SUPPORT_PASSKEY,
                };
            }
            const credential = (await navigator.credentials.create({
                publicKey: _a.publicKeyCredentialCreationOptions(appName, name, displayName, yubikeyOnly),
            }));
            _a._createdCredential = credential;
            return {
                data: credential,
                response: credential.response,
                error: null,
            };
        }
        catch (e) {
            logger.error(PASSKEY_ERRORS.USER_REJECTED_CREDENTIAL, e);
            return {
                data: null,
                response: null,
                error: PASSKEY_ERRORS.USER_REJECTED_CREDENTIAL,
            };
        }
    }
    static publicKeyCredentialCreationOptions(appName, name, displayName, yubikeyOnly) {
        return {
            challenge: crypto.getRandomValues(new Uint8Array(16)),
            rp: {
                name: appName,
            },
            user: {
                id: crypto.getRandomValues(new Uint8Array(16)),
                name: name ? name : displayName,
                displayName: displayName,
            },
            pubKeyCredParams: [
                {
                    type: "public-key",
                    alg: -7,
                },
            ],
            timeout: 60000,
            attestation: "direct",
            ...(yubikeyOnly && {
                authenticatorSelection: {
                    authenticatorAttachment: "cross-platform",
                },
            }),
        };
    }
    static async getPublicKeyXYCoordinate(publicKey) {
        let jwkKey;
        try {
            jwkKey = await window.crypto.subtle.exportKey("jwk", publicKey);
            logger.debug("JWK key :", jwkKey);
        }
        catch (err) {
            console.error("Failed to export key:", err);
            return;
        }
        if (jwkKey) {
            const pubKeyX = `0x${_a.buf2hex(_a.parseBase64url(jwkKey.x))}`;
            const pubKeyY = `0x${_a.buf2hex(_a.parseBase64url(jwkKey.y))}`;
            logger.debug("pubKeyX:", pubKeyX);
            logger.debug("pubKeyY:", pubKeyY);
            return [pubKeyX, pubKeyY];
        }
    }
    static async getPasskeySignatureData(challenge, allowCredentials) {
        let assertion;
        try {
            logger.debug("(🪪,ℹ️) Obtaining credentials");
            const challengeBuf = _a.hex2buf(challenge.substring(2));
            logger.debug("(🪄,ℹ️) Challenge", challenge);
            logger.debug("(🪄,ℹ️) Challenge (base64)", _a.toBase64url(challengeBuf));
            logger.debug("(🪄,ℹ️) Challenge (hex)", _a.buf2hex(challengeBuf));
            const publicKeyCredentialRequestOptions = {
                challenge: challengeBuf,
                timeout: 60000,
                allowCredentials,
            };
            assertion = (await navigator.credentials.get({
                publicKey: publicKeyCredentialRequestOptions,
            }));
        }
        catch (e) {
            logger.error(PASSKEY_ERRORS.UNABLE_TO_RETRIEVE_CREDENTIAL, e);
            return {
                authenticatorData: "",
                requireUserVerification: false,
                clientDataJson: "",
                challengeLocation: 0,
                responseTypeLocation: 0,
                r: "",
                s: "",
                error: PASSKEY_ERRORS.UNABLE_TO_RETRIEVE_CREDENTIAL,
            };
        }
        if (!assertion) {
            return {
                authenticatorData: "",
                requireUserVerification: false,
                clientDataJson: "",
                challengeLocation: 0,
                responseTypeLocation: 0,
                r: "",
                s: "",
                error: PASSKEY_ERRORS.UNABLE_TO_RETRIEVE_CREDENTIAL,
            };
        }
        logger.debug("(🪪,✅) Assertion", assertion);
        logger.debug({
            title: "Assertion obtained.",
            description: "Your assertion has been retrieved.",
            status: "success",
            duration: 9000,
            isClosable: true,
        });
        const assertation = assertion.response;
        // rough lengths per attr: signature = 140+/-5, authenticatorData = 74, clientData = 200+
        logger.debug("(📥,ℹ️), assertation", assertation);
        const { signature, clientDataJSON, authenticatorData } = assertation;
        const obtainedClientDataJSON = JSON.parse(new TextDecoder().decode(clientDataJSON));
        const authenticatorDataString = `0x${_a.buf2hex(authenticatorData)}`;
        const clientDataJSONString = JSON.stringify(obtainedClientDataJSON);
        const challengeLocation = 23;
        const responseTypeLocation = 1;
        const requireUserVerification = false;
        const { r, s } = _a.normalizeSignature(signature);
        const rValue = `0x${BigInt(r).toString(16)}`;
        const sValue = `0x${BigInt(s).toString(16)}`;
        logger.debug({
            authenticatorData: authenticatorDataString,
            requireUserVerification,
            clientDataJson: clientDataJSONString,
            challengeLocation,
            responseTypeLocation,
            r: rValue,
            s: sValue,
        });
        return {
            authenticatorData: authenticatorDataString,
            requireUserVerification,
            clientDataJson: clientDataJSONString,
            challengeLocation,
            responseTypeLocation,
            r: rValue,
            s: sValue,
            error: null,
        };
    }
    static normalizeSignature(signature) {
        // Convert signature from ASN.1 sequence to "raw" format
        const usignature = new Uint8Array(signature);
        const rStart = usignature[4] === 0 ? 5 : 4;
        const rEnd = rStart + 32;
        const sStart = usignature[rEnd + 2] === 0 ? rEnd + 3 : rEnd + 2;
        const r = BigInt(`0x${_a.buf2hex(usignature.slice(rStart, rEnd))}`);
        let s = BigInt(`0x${_a.buf2hex(usignature.slice(sStart))}`);
        // Avoid malleability. Ensure low S (<= N/2 where N is the curve order)
        const n = BigInt("0xFFFFFFFF00000000FFFFFFFFFFFFFFFFBCE6FAADA7179E84F3B9CAC2FC632551");
        if (s > n / BigInt(2)) {
            s = n - s;
        }
        return { r, s };
    }
    static buf2hex(buffer) {
        return [...new Uint8Array(buffer)]
            .map((x) => x.toString(16).padStart(2, "0"))
            .join("");
    }
    static hex2buf(hex) {
        return new Uint8Array(hex.match(/[\da-f]{2}/gi).map((h) => parseInt(h, 16)));
    }
    static parseBase64url(txt) {
        const base64Txt = txt.replaceAll("-", "+").replaceAll("_", "/"); // base64url -> base64
        return _a.toBuffer(atob(base64Txt));
    }
    static toBuffer(txt) {
        return Uint8Array.from(txt, (c) => c.charCodeAt(0)).buffer;
    }
    static toBase64url(buffer) {
        const txt = btoa(_a.parseBuffer(buffer)); // base64
        return txt.replaceAll("+", "-").replaceAll("/", "_");
    }
    static parseBuffer(buffer) {
        return String.fromCharCode(...new Uint8Array(buffer));
    }
}
_a = Passkey;
// NB: Passkey is the easiest way to parse the DER format from the getPublicKey method given the webauthn
// navigator.credentials.create({ ... }).response object. Do not try to mess with CBOR against Passkey
// ArrayBuffer directly, as it does not have enough data to be parsed properly via CBOR.
Passkey.importPublicKeyAsCryptoKey = async (publicKey) => {
    logger.debug("(🔑,ℹ️) Parsing webauthn response public key as CryptoKey via Web Crypto API");
    try {
        const key = await crypto.subtle.importKey(
        // The getPublicKey() operation thus returns the credential public key as a SubjectPublicKeyInfo. See:
        // https://w3c.github.io/webauthn/#sctn-public-key-easy
        // crypto.subtle can import the spki format:
        // https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/importKey
        "spki", // "spki" Simple Public Key Infrastructure rfc2692
        publicKey, {
            // these are the algorithm options
            // await cred.response.getPublicKeyAlgorithm() // returns -7
            // -7 is ES256 with P-256 // search -7 in https://w3c.github.io/webauthn
            // the W3C webcrypto docs:
            // https://www.w3.org/TR/WebCryptoAPI/#informative-references (scroll down a bit)
            // ES256 corrisponds with the following AlgorithmIdentifier:
            name: "ECDSA",
            namedCurve: "P-256",
            hash: { name: "SHA-256" },
        }, true, //whether the key is extractable (i.e. can be used in exportKey)
        ["verify"]);
        return key;
    }
    catch (e) {
        logger.error(PASSKEY_ERRORS.PUBLIC_KEY_CANT_BE_PARSED_AS_CRYPTO_KEY, e);
        return null;
    }
};
Passkey.verifySignature = async ({ publicKey, assertation }) => {
    // rough lengths per attr: signature = 140+/-5, authenticatorData = 74, clientData = 200+
    logger.debug('(📥,ℹ️), assertation', assertation);
    const { signature, clientDataJSON, authenticatorData } = assertation;
    logger.debug('(🖊️,ℹ️), signature', _a.buf2hex(signature), _a.buf2hex(signature).length);
    logger.debug('(👤,ℹ️), clientDataJSON', _a.buf2hex(clientDataJSON), _a.buf2hex(clientDataJSON).length);
    logger.debug('(🔑,ℹ️), authenticatorData', _a.buf2hex(authenticatorData), _a.buf2hex(authenticatorData).length);
    const obtainedClientDataJSON = JSON.parse(new TextDecoder().decode(clientDataJSON));
    logger.debug('(👤,ℹ️), clientDataJSON (parsed)', obtainedClientDataJSON);
    logger.debug('(👤,ℹ️), challenge (from clientDataJSON)', _a.buf2hex(_a.parseBase64url(obtainedClientDataJSON.challenge)));
    // logger.debug('(👀,ℹ️), challenge', this.buf2hex(new TextEncoder().encode(obtainedClientDataJSON.challenge)));
    const authenticatorDataAsUint8Array = new Uint8Array(authenticatorData);
    const clientDataHash = new Uint8Array(await crypto.subtle.digest("SHA-256", clientDataJSON));
    // concat authenticatorData and clientDataHash
    const signedData = new Uint8Array(authenticatorDataAsUint8Array.length + clientDataHash.length);
    signedData.set(authenticatorDataAsUint8Array);
    signedData.set(clientDataHash, authenticatorDataAsUint8Array.length);
    // import key
    var key = await _a.importPublicKeyAsCryptoKey(publicKey);
    // Convert signature from ASN.1 sequence to "raw" format
    var usignature = new Uint8Array(signature);
    var rStart = usignature[4] === 0 ? 5 : 4;
    var rEnd = rStart + 32;
    var sStart = usignature[rEnd + 2] === 0 ? rEnd + 3 : rEnd + 2;
    var r = usignature.slice(rStart, rEnd);
    var s = usignature.slice(sStart);
    var rawSignature = new Uint8Array([...r, ...s]);
    // check signature with public key and signed data 
    var verified = await crypto.subtle.verify({ name: "ECDSA", namedCurve: "P-256", hash: { name: "SHA-256" } }, key, rawSignature, signedData.buffer);
    return { isValid: verified, signature: rawSignature, data: signedData };
};

class ZeroTrustAccount {
    /**
     * @notice Create ZeroTrustAccount instance to interact with
     * @param provider provider to use
     */
    constructor(provider, entryPointAddress, accountFactoryAddress, passkeyMetaInfo) {
        this._passkeyMetaInfo = passkeyMetaInfo;
        this._zeroTrustAccountFactoryAddress = accountFactoryAddress;
        this._provider = provider;
        this._zeroTrustAccountFactory = new Contract(accountFactoryAddress, ZERO_TRUST_ACCOUNT_FACTORY_ABI, this._provider);
        this._entryPoint = new Contract(entryPointAddress, ENTRY_POINT_ABI, this._provider);
    }
    getEntryPointContract() {
        return this._entryPoint;
    }
    getInitCode() {
        const initCode = ethers.concat([
            this._zeroTrustAccountFactoryAddress,
            this._zeroTrustAccountFactory.interface.encodeFunctionData("createAccount", [
                this._passkeyMetaInfo.pubKeyX,
                this._passkeyMetaInfo.pubKeyY,
                this._passkeyMetaInfo.salt,
                this._passkeyMetaInfo.credentialId,
            ]),
        ]);
        return initCode;
    }
    async getCounterfactualAccountAddress() {
        try {
            const initCode = this.getInitCode();
            // CALCULATE THE SENDER ADDRESS
            const senderAddress = await this._entryPoint.getSenderAddress
                .staticCall(initCode)
                .then(() => {
                throw new Error("Expected getSenderAddress() to revert");
            })
                .catch((e) => {
                const data = e.data.match(/0x6ca7b806([a-fA-F\d]*)/)?.[1];
                if (!data) {
                    return Promise.reject(new Error("Failed to parse revert data"));
                }
                const addr = ethers.getAddress(`0x${data.slice(24, 64)}`);
                return Promise.resolve(addr);
            });
            logger.debug("Calculated sender address:", senderAddress);
            return senderAddress;
        }
        catch (err) {
            logger.error(err);
        }
        return null;
    }
    getContract(address) {
        return new Contract(address, ZERO_TRUST_ACCOUNT_ABI, this._provider);
    }
    static getContract(address, provider) {
        return new Contract(address, ZERO_TRUST_ACCOUNT_ABI, provider);
    }
    async execute(targetContract, funCalldata, bundlerProvider, paymasterProvider) {
        try {
            const address = await this.getCounterfactualAccountAddress();
            const gasPrice = (await this._provider.getFeeData()).gasPrice;
            logger.debug(gasPrice);
            const nonceValue = await getNonceValue(address, this._provider);
            logger.debug(`Account Nonce:${nonceValue}`);
            const chainId = await this._provider.getNetwork().then(network => network.chainId);
            logger.debug(`ChainId:${chainId}`);
            logger.debug(`Target Contract Address:${targetContract}`);
            const value = ethers.parseEther('0');
            const accountContract = this.getContract(address);
            const callData = accountContract.interface.encodeFunctionData("execute", [targetContract, value, funCalldata]);
            logger.debug(`calldata :${callData}`);
            const userOperation = {
                sender: address,
                nonce: "0x" + nonceValue.toString(16),
                initCode: nonceValue === 0 ? this.getInitCode() : '0x',
                callData,
                callGasLimit: "0x" + BigInt(2000000).toString(16),
                verificationGasLimit: "0x" + BigInt(2000000).toString(16),
                preVerificationGas: "0x" + BigInt(2000000).toString(16),
                maxFeePerGas: "0x" + gasPrice.toString(16),
                maxPriorityFeePerGas: "0x" + gasPrice.toString(16),
                paymasterAndData: "0x",
                signature: "0x"
            };
            const entryPointContractAddress = this._entryPoint.target;
            logger.debug(`Partial UserOps :${userOperation}`);
            logger.debug(`Getting paymaster sponsorship`);
            const sponsorUserOperationResult = await paymasterProvider.send("pm_sponsorUserOperation", [
                userOperation,
                {
                    entryPoint: entryPointContractAddress,
                },
            ]);
            const paymasterAndData = sponsorUserOperationResult.paymasterAndData;
            logger.debug(`Paymaster response ${sponsorUserOperationResult}`);
            if (paymasterAndData) {
                userOperation.paymasterAndData = paymasterAndData;
                const userOpHash = await this._entryPoint.getUserOpHash(userOperation);
                const allowCredentials = [{
                        id: Passkey.parseBase64url(ethers.toUtf8String(this._passkeyMetaInfo.credentialId)),
                        type: 'public-key'
                    }];
                const { authenticatorData, clientDataJson, challengeLocation, requireUserVerification, responseTypeLocation, r, s, error } = await Passkey.getPasskeySignatureData(userOpHash, allowCredentials);
                if (!error) {
                    const sessionMode = '0x00000000';
                    const defaultAbiCoder = ethers.AbiCoder.defaultAbiCoder();
                    const passKeySignatureStruct = defaultAbiCoder.encode([
                        'tuple(uint256,uint256,uint256,uint256,bool,bytes,string)'
                    ], [
                        [challengeLocation,
                            responseTypeLocation,
                            r,
                            s,
                            requireUserVerification,
                            authenticatorData,
                            clientDataJson
                        ]
                    ]).substring(2);
                    const encodedSignature = defaultAbiCoder.encode(['bytes4'], [sessionMode]) + passKeySignatureStruct;
                    userOperation.signature = encodedSignature;
                    const userOperationHash = await bundlerProvider.send("eth_sendUserOperation", [
                        userOperation,
                        entryPointContractAddress
                    ]);
                    let receipt = null;
                    while (receipt === null) {
                        await new Promise((resolve) => setTimeout(resolve, 1000));
                        receipt = await bundlerProvider.send("eth_getUserOperationReceipt", [userOperationHash]);
                    }
                    logger.debug(receipt);
                    return { error: null, response: receipt };
                }
                else {
                    const errorMessage = `Failed to generate passkey signature: ${error}`;
                    return { error: errorMessage, response: null };
                }
            }
            else {
                return { error: 'Invalid PaymasterAndData.', response: null };
            }
        }
        catch (error) {
            console.error('Error executing the transaction:', error);
            return { error: 'Error executing the transaction', response: null };
        }
    }
    async payableExecute(funCalldata, bundlerProvider, paymasterProvider) {
    }
    async createSession(applicationName, session, bundlerProvider, paymasterProvider) {
        try {
            const address = await this.getCounterfactualAccountAddress();
            const gasPrice = (await this._provider.getFeeData()).gasPrice;
            logger.debug(gasPrice);
            const nonceValue = await getNonceValue(address, this._provider);
            logger.debug(`Account Nonce:${nonceValue}`);
            const chainId = await this._provider.getNetwork().then(network => network.chainId);
            logger.debug(`ChainId:${chainId}`);
            const value = ethers.parseEther('0');
            const accountContract = this.getContract(address);
            // const session :ISessionAccount.SessionStruct= {
            // 		allowedContracts:1,
            // 		allowedInactiveDuration:0,
            // 		extendWithInactiveDuration:false,
            // 		sessionCommitment:'',
            // 		validAfter:'',
            // 		validUntil:''
            // }
            const callData = accountContract.interface.encodeFunctionData("setApplicationSession", [ethers.keccak256(ethers.toUtf8Bytes(applicationName)), session]);
            logger.debug(`calldata :${callData}`);
            const userOperation = {
                sender: address,
                nonce: "0x" + nonceValue.toString(16),
                initCode: nonceValue === 0 ? this.getInitCode() : '0x',
                callData,
                callGasLimit: "0x" + BigInt(2000000).toString(16),
                verificationGasLimit: "0x" + BigInt(2000000).toString(16),
                preVerificationGas: "0x" + BigInt(2000000).toString(16),
                maxFeePerGas: "0x" + gasPrice.toString(16),
                maxPriorityFeePerGas: "0x" + gasPrice.toString(16),
                paymasterAndData: "0x",
                signature: "0x"
            };
            const entryPointContractAddress = this._entryPoint.target;
            logger.debug(`Partial UserOps :${userOperation}`);
            logger.debug(`Getting paymaster sponsorship`);
            const sponsorUserOperationResult = await paymasterProvider.send("pm_sponsorUserOperation", [
                userOperation,
                {
                    entryPoint: entryPointContractAddress,
                },
            ]);
            const paymasterAndData = sponsorUserOperationResult.paymasterAndData;
            logger.debug(`Paymaster response ${sponsorUserOperationResult}`);
            if (paymasterAndData) {
                userOperation.paymasterAndData = paymasterAndData;
                const userOpHash = await this._entryPoint.getUserOpHash(userOperation);
                const allowCredentials = [{
                        id: Passkey.parseBase64url(ethers.toUtf8String(this._passkeyMetaInfo.credentialId)),
                        type: 'public-key'
                    }];
                const { authenticatorData, clientDataJson, challengeLocation, requireUserVerification, responseTypeLocation, r, s, error } = await Passkey.getPasskeySignatureData(userOpHash, allowCredentials);
                if (!error) {
                    const sessionMode = '0x00000000';
                    const defaultAbiCoder = ethers.AbiCoder.defaultAbiCoder();
                    const passKeySignatureStruct = defaultAbiCoder.encode([
                        'tuple(uint256,uint256,uint256,uint256,bool,bytes,string)'
                    ], [
                        [challengeLocation,
                            responseTypeLocation,
                            r,
                            s,
                            requireUserVerification,
                            authenticatorData,
                            clientDataJson
                        ]
                    ]).substring(2);
                    const encodedSignature = defaultAbiCoder.encode(['bytes4'], [sessionMode]) + passKeySignatureStruct;
                    userOperation.signature = encodedSignature;
                    const userOperationHash = await bundlerProvider.send("eth_sendUserOperation", [
                        userOperation,
                        entryPointContractAddress
                    ]);
                    if (userOperationHash) {
                        let receipt = null;
                        while (receipt === null) {
                            logger.debug('wating for receipt...');
                            await new Promise((resolve) => setTimeout(resolve, 1000));
                            receipt = await bundlerProvider.send("eth_getUserOperationReceipt", [userOperationHash]);
                        }
                        logger.debug(receipt);
                        return { error: null, response: receipt };
                    }
                    else {
                        return { error: 'Some error occurred on submitting user operation', response: null };
                    }
                }
                else {
                    const errorMessage = `Failed to generate passkey signature: ${error}`;
                    return { error: errorMessage, response: null };
                }
            }
            else {
                return { error: 'Invalid PaymasterAndData.', response: null };
            }
        }
        catch (error) {
            console.error('Error occurred while creating the session', error);
            return { error: 'Error occurred while creating the session', response: null };
        }
    }
    login() { }
}

var Account_Registry_ABI = [
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "bytes32",
				name: "username",
				type: "bytes32"
			},
			{
				indexed: false,
				internalType: "address",
				name: "accountAddress",
				type: "address"
			},
			{
				components: [
					{
						internalType: "enum IAccountRegistry.SignerType",
						name: "signerType",
						type: "uint8"
					},
					{
						internalType: "uint256",
						name: "pubKeyX",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "pubKeyY",
						type: "uint256"
					},
					{
						internalType: "bytes",
						name: "id",
						type: "bytes"
					},
					{
						internalType: "bytes",
						name: "domainUrl",
						type: "bytes"
					}
				],
				indexed: false,
				internalType: "struct IAccountRegistry.SignerInfo",
				name: "signerInfo",
				type: "tuple"
			}
		],
		name: "AccountMetaInfoAdded",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "bytes32",
				name: "username",
				type: "bytes32"
			},
			{
				indexed: false,
				internalType: "address",
				name: "accountAddress",
				type: "address"
			},
			{
				components: [
					{
						internalType: "enum IAccountRegistry.SignerType",
						name: "signerType",
						type: "uint8"
					},
					{
						internalType: "uint256",
						name: "pubKeyX",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "pubKeyY",
						type: "uint256"
					},
					{
						internalType: "bytes",
						name: "id",
						type: "bytes"
					},
					{
						internalType: "bytes",
						name: "domainUrl",
						type: "bytes"
					}
				],
				indexed: false,
				internalType: "struct IAccountRegistry.SignerInfo",
				name: "signerInfo",
				type: "tuple"
			}
		],
		name: "AccountMetaInfoUpdated",
		type: "event"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "_username",
				type: "bytes32"
			},
			{
				components: [
					{
						internalType: "enum IAccountRegistry.SignerType",
						name: "signerType",
						type: "uint8"
					},
					{
						internalType: "uint256",
						name: "pubKeyX",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "pubKeyY",
						type: "uint256"
					},
					{
						internalType: "bytes",
						name: "id",
						type: "bytes"
					},
					{
						internalType: "bytes",
						name: "domainUrl",
						type: "bytes"
					}
				],
				internalType: "struct IAccountRegistry.SignerInfo",
				name: "_signerInfo",
				type: "tuple"
			}
		],
		name: "addAccountMetaInfo",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "_username",
				type: "bytes32"
			}
		],
		name: "getAccountMetaInfo",
		outputs: [
			{
				components: [
					{
						internalType: "address",
						name: "accountAddress",
						type: "address"
					},
					{
						components: [
							{
								internalType: "enum IAccountRegistry.SignerType",
								name: "signerType",
								type: "uint8"
							},
							{
								internalType: "uint256",
								name: "pubKeyX",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "pubKeyY",
								type: "uint256"
							},
							{
								internalType: "bytes",
								name: "id",
								type: "bytes"
							},
							{
								internalType: "bytes",
								name: "domainUrl",
								type: "bytes"
							}
						],
						internalType: "struct IAccountRegistry.SignerInfo",
						name: "signerInfo",
						type: "tuple"
					}
				],
				internalType: "struct IAccountRegistry.AccountMetaInfo",
				name: "",
				type: "tuple"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "_username",
				type: "bytes32"
			},
			{
				components: [
					{
						internalType: "enum IAccountRegistry.SignerType",
						name: "signerType",
						type: "uint8"
					},
					{
						internalType: "uint256",
						name: "pubKeyX",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "pubKeyY",
						type: "uint256"
					},
					{
						internalType: "bytes",
						name: "id",
						type: "bytes"
					},
					{
						internalType: "bytes",
						name: "domainUrl",
						type: "bytes"
					}
				],
				internalType: "struct IAccountRegistry.SignerInfo",
				name: "_signerInfo",
				type: "tuple"
			}
		],
		name: "updateAccountMetaInfo",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	}
];

function getAccountRegistryContract(address, signerOrProvider) {
    return new Contract(address, Account_Registry_ABI, signerOrProvider);
}

function checkParameter(value, name, type) {
    if (typeof value !== type) {
        throw new TypeError(`Parameter '${name}' is not a ${type}`);
    }
}
/**
 * Checks if a string is a JSON.
 * @param jsonString The JSON string.
 * @returns True or false.
 */
function isJsonArray(jsonString) {
    try {
        return Array.isArray(JSON.parse(jsonString));
    }
    catch (error) {
        return false;
    }
}
/**
 * Generates a random big number.
 * @param numberOfBytes The number of bytes of the number.
 * @returns The generated random number.
 */
function genRandomNumber(numberOfBytes = 31) {
    return BigNumber.from(randomBytes(numberOfBytes)).toBigInt();
}
function padArrayWithZeros(array) {
    const paddedArray = [...array];
    while (paddedArray.length < 16) {
        paddedArray.push(BigInt(0));
    }
    return paddedArray;
}
function poseidon(input) {
    const length = input.length;
    switch (length) {
        case 1: return poseidon1(input);
        case 2: return poseidon2(input);
        case 3: return poseidon3(input);
        case 4: return poseidon4(input);
        case 5: return poseidon5(input);
        case 6: return poseidon6(input);
        case 7: return poseidon7(input);
        case 8: return poseidon8(input);
        case 9: return poseidon9(input);
        case 10: return poseidon10(input);
        case 11: return poseidon11(input);
        case 12: return poseidon12(input);
        case 13: return poseidon13(input);
        case 14: return poseidon14(input);
        case 15: return poseidon15(input);
        case 16: return poseidon16(input);
        default: throw new Error(`poseidon: Unsupported array length: ${length}`);
    }
}

class ZeroTrustSession {
    constructor(applicationScopes, identityOrMessage) {
        if (identityOrMessage === undefined) {
            this._trapdoor = genRandomNumber();
            this._nullifier = genRandomNumber();
        }
        else {
            checkParameter(identityOrMessage, "identityOrMessage", "string");
            [this._trapdoor, this._nullifier] = this.generateTrapdoorAndNullifier(identityOrMessage);
        }
        this._applicationScopeHash = this.calculateApplicationScopeHash(applicationScopes);
        this._secret = poseidon3([this._nullifier, this._trapdoor, this._applicationScopeHash]);
        this._commitment = poseidon1([this._secret]);
    }
    generateTrapdoorAndNullifier(identityOrMessage) {
        if (isJsonArray(identityOrMessage)) {
            const [trapdoor, nullifier] = JSON.parse(identityOrMessage);
            return [BigInt(trapdoor), BigInt(nullifier)];
        }
        else {
            const h = hash.sha512(identityOrMessage).padStart(128, "0");
            const trapdoor = BigInt(`0x${h.slice(64)}`) >> BigInt(3);
            const nullifier = BigInt(`0x${h.slice(0, 64)}`) >> BigInt(3);
            return [trapdoor, nullifier];
        }
    }
    calculateApplicationScopeHash(scopes) {
        logger.debug(scopes);
        const contractCount = Object.keys(scopes).length;
        if (!scopes || contractCount <= 0 || contractCount > 16) {
            throw new Error('Application Scope must have 1 to 16 contracts.');
        }
        const entries = Object.entries(scopes);
        const applicationContractsPoseidonSet = entries.map(contractLevelScope => {
            const contract = BigInt(contractLevelScope[0]);
            const methodSelectors = padArrayWithZeros(contractLevelScope[1].map(selector => BigInt(selector)));
            const methodSelectorPoseidonHash = poseidon16(methodSelectors);
            return poseidon2([contract, methodSelectorPoseidonHash]);
        });
        return poseidon(applicationContractsPoseidonSet);
    }
    /**
     * Returns the identity trapdoor.
     * @returns The identity trapdoor.
     */
    get trapdoor() {
        return this._trapdoor;
    }
    /**
     * Returns the identity trapdoor.
     * @returns The identity trapdoor.
     */
    getTrapdoor() {
        return this._trapdoor;
    }
    /**
     * Returns the identity nullifier.
     * @returns The identity nullifier.
     */
    get nullifier() {
        return this._nullifier;
    }
    /**
     * Returns the identity nullifier.
     * @returns The identity nullifier.
     */
    getNullifier() {
        return this._nullifier;
    }
    /**
     * Returns the session scopes hash.
     * @returns The session scopes hash.
     */
    get scopeSetHash() {
        return this._applicationScopeHash;
    }
    /**
     * Returns the session scopes hash.
     * @returns The session scopes hash.
     */
    getScopeSetHash() {
        return this._applicationScopeHash;
    }
    /**
     * Returns the identity secret.
     * @returns The identity secret.
     */
    get secret() {
        return this._secret;
    }
    /**
     * Returns the identity secret.
     * @returns The identity secret.
     */
    getSecret() {
        return this._secret;
    }
    /**
     * Returns the identity commitment.
     * @returns The identity commitment.
     */
    get commitment() {
        return this._commitment;
    }
    /**
     * Returns the identity commitment.
     * @returns The identity commitment.
     */
    getCommitment() {
        return this._commitment;
    }
    /**
     * Returns a JSON string with trapdoor and nullifier. It can be used
     * to export the identity and reuse it later.
     * @returns The string representation of the identity.
     */
    toIdentityString() {
        return JSON.stringify([`0x${this._trapdoor.toString(16)}`, `0x${this._nullifier.toString(16)}`]);
    }
    /**
     * Returns a JSON string with trapdoor and nullifier. It can be used
     * to export the identity and reuse it later.
     * @returns The string representation of the identity.
     */
    toString() {
        return JSON.stringify([`0x${this._trapdoor.toString(16)}`, `0x${this._nullifier.toString(16)}`, `0x${this._applicationScopeHash.toString(16)}`]);
    }
}

function packProof(originalProof) {
    return [
        originalProof.pi_a[0],
        originalProof.pi_a[1],
        originalProof.pi_b[0][1],
        originalProof.pi_b[0][0],
        originalProof.pi_b[1][1],
        originalProof.pi_b[1][0],
        originalProof.pi_c[0],
        originalProof.pi_c[1]
    ];
}
async function generateProof(identityTrapdoor, identityNullifier, externalNullifier, // userOps Hash
contracts, scope, actionContractIndex, actionScopeIndex, snarkArtifacts) {
    if (!snarkArtifacts) {
        // Construct local file paths
        const wasmFilePath = `/assets/${contracts.length}/Session.wasm`;
        const zkeyFilePath = `/assets/${contracts.length}/Session.zkey`;
        snarkArtifacts = { wasmFilePath, zkeyFilePath };
    }
    const { proof, publicSignals } = await groth16.fullProve({
        identityTrapdoor: identityTrapdoor,
        identityNullifier: identityNullifier,
        externalNullifier: externalNullifier,
        contracts: contracts,
        scope: scope,
        actionContractIndex: actionContractIndex,
        actionScopeIndex: actionScopeIndex,
    }, snarkArtifacts.wasmFilePath, snarkArtifacts.zkeyFilePath);
    const { a, b, c, Input } = await solidityCalldata(proof, publicSignals);
    return {
        proof: [a[0], a[1], b[0][0], b[0][1], b[1][0], b[1][1], c[0], c[1]],
        publicSignals: Input
    };
}
async function solidityCalldata(_proof, _publicSignals) {
    const calldata = await groth16.exportSolidityCallData(_proof, _publicSignals);
    logger.debug(calldata);
    const argv = calldata
        .replace(/["[\]\s]/g, "")
        .split(",")
        .map((x) => x);
    const a = [argv[0], argv[1]];
    const b = [
        [argv[2], argv[3]],
        [argv[4], argv[5]]
    ];
    const c = [argv[6], argv[7]];
    const Input = [];
    for (let i = 8; i < argv.length; i++) {
        Input.push(argv[i]);
    }
    return { a, b, c, Input };
}

export { Passkey, ZeroTrustAccount, ZeroTrustSession, generateProof, getAccountRegistryContract, packProof, solidityCalldata, truncate };
